import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]

  connect() {
    // Set initial state - first tab is active by default
    this.showPanel(this.tabTargets[0]?.dataset.tabsPanel)
  }

  select(event) {
    const panelName = event.currentTarget.dataset.tabsPanel
    this.showPanel(panelName)
  }

  showPanel(panelName) {
    if (!panelName) return

    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tabsPanel === panelName) {
        tab.classList.remove(...this.inactiveClasses)
        tab.classList.add(...this.activeClasses)
      } else {
        tab.classList.remove(...this.activeClasses)
        tab.classList.add(...this.inactiveClasses)
      }
    })

    // Show/hide panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tabsPanel === panelName) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
